import { useState, createContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./views/Home/HomePage";
import BasicContentPage from "./views/Chapter/BasicContentPage";
import AdvancedContentPage from "./views/Chapter/AdvancedContentPage";
import ContentPage from "./views/Content/ContentPage";
import TeacherPage from "./views/old_views/TeacherPage";
import LoginPage from './views/Login/LoginPage';
import ProfileLayout from './views/Home/MainLayout';
import NavBar from './components/HomePages/NavBar';
import { AuthProvider } from "./state/AuthContext";
import { DataProvider } from "./state/DataContext"; // Import DataProvider
import withAuthGuard from "./components/withAuthGuard";
import AuthenticatedAppProviders from "./components/AuthenticatedAppProviders";

export const ThemeContext = createContext("light");

function ContentWrapper({ children }) {
  const [theme, setTheme] = useState("light");
  const toggleTheme = () => setTheme((curr) => (curr === "light" ? "dark" : "light"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div className={`content-theme ${theme}`}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <DataProvider> {/* DataProvider now wraps everything */}
          <NavBar />
          <AuthenticatedAppProviders>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/teacher" element={<TeacherPage />} />

              {/* Protected Routes */}
              <Route path="/advanced" element={<ProtectedAdvancedContentPage />} />
              <Route path="/basic" element={<ProtectedBasicContentPage />} />
              <Route path="/profile" element={<ProtectedProfileLayout />} />
              
              <Route path="/:courseType/:sectionSlug" element={<ContentWrapper><ContentPage/></ContentWrapper>} />
            </Routes>
          </AuthenticatedAppProviders>
        </DataProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;

const ProtectedBasicContentPage = withAuthGuard(BasicContentPage, "/login");
const ProtectedAdvancedContentPage = withAuthGuard(AdvancedContentPage, "/login");
const ProtectedProfileLayout = withAuthGuard(ProfileLayout, "/login");